var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFloorplanCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.20801,
    y: 3.25488,
    width: 13.4878,
    height: 13.4878,
    rx: 1.5,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.70801 8.26559C3.70801 8.26559 6.56213 8.26558 8.39093 8.26558M8.39093 8.26558L8.39093 10M8.39093 8.26558L8.39093 6.87805",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.71 3.75488V6.87683V9.99878",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2921 13.6211H16.7921V12.6211H16.2921V13.6211ZM8.38965 12.6211C8.11351 12.6211 7.88965 12.845 7.88965 13.1211C7.88965 13.3972 8.11351 13.6211 8.38965 13.6211V12.6211ZM16.2921 12.6211H8.38965V13.6211H16.2921V12.6211Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFloorplanCard);
export default __webpack_public_path__ + "static/media/icon-floorplan-card.0db75df3fd22d386d4a5b6afd06899cd.svg";
export { ForwardRef as ReactComponent };